import React, { useState } from 'react';
import { PUBLIC_PATH } from '../../../../../shared/config/routes-config';
import Button, {
  ButtonSize
} from '../../../../../shared/components/core-ui/button/button.component';
import { trackEvent } from '../../../../../shared/services/utils/tracking/tracking.service';
import useWindowResizer from '../../../../../shared/hooks/window-resizer/window-resizer.hook';
import { ConfirmModal } from '../../components/confirm-modal/confirm-modal.component';
import { ManagersList } from '../managers-list/managers-list.container';

export interface ManagerInfoProps {
  data: {
    propertyManagersList: {
      id: string;
      name: string;
      email: string;
      phone: string;
      role: string;
      roles: string[];
    }[];
    propertyId?: string;
    reservationId?: string;
    title?: string;
  };
  eventHandlers: {
    addPropertyManager: (show: boolean) => void;
    updatePropertyManager?: (id: string) => void;
    deletePropertyManager: (id: string) => void;
  };
}
export const ManagerInfo: React.FC<ManagerInfoProps> = ({ data, eventHandlers }) => {
  const isMobileView = useWindowResizer();
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [selectedUser, setSelectedUser] = useState<string>('');

  return (
    <div className="flex-1 mt-4 pb-8 rounded-lg bg-white shadow-md p-6 w-full">
      {data?.propertyManagersList?.length > 0 ? (
        <>
          <div className="font-bold text-neutral-500 text-2xl mb-4">
            {data.title || 'Internal Emails Subscription List'}
          </div>
          <div className="flex flex-row flex-wrap">
            <ManagersList
              data={{ propertyManagersList: data?.propertyManagersList }}
              eventHandlers={{
                deletePropertyManager: (id: string) => {
                  setSelectedUser(id);
                  setShowDeleteModal(true);
                },
                addPropertyManager: () => eventHandlers.addPropertyManager(true)
              }}
            />
          </div>
        </>
      ) : (
        <div>
          <img
            src={`${PUBLIC_PATH}/assets/jpeg/add-guest.jpeg`}
            alt="assign Homeowner"
            className="block mx-auto"
          />

          <Button
            onClick={() => {
              eventHandlers.addPropertyManager(true);
              trackEvent('record_saved', {
                entity: 'unit_type',
                action: 'create',
                outcome: 'success'
              });
            }}
            tracking={{ event: 'record_edit_cancelled', entity: 'manager', method: 'cancel' }}
            size={isMobileView ? ButtonSize.full : ButtonSize.medium}
            disabled={data.propertyId === '' && data.reservationId === ''}
          >
            {' '}
            Assign Property Manager
          </Button>
        </div>
      )}

      <ConfirmModal
        config={{
          showModal: showDeleteModal,
          message: 'Are you sure you want to delete this manager?'
        }}
        eventHandlers={{
          denyAction: () => {
            setShowDeleteModal(false);
          },
          confirmAction: () => {
            setShowDeleteModal(false);
            eventHandlers.deletePropertyManager(selectedUser);
          }
        }}
      />
    </div>
  );
};
